import React, { useMemo } from 'react'
import { Container, Icon } from 'gu-ui-kit'
import styles from 'modules/Finance/PaymentProfiles/Invoices/components/StatusIcon/status-icon.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const StatusIcon = ({ status, breakpoints }) => {
  const iconConf = useMemo(() => {
    switch (status) {
      case 'new':
        return { name: 'transaction new', color: 'Label-Secondary' }
      case 'pending':
        return { name: 'transaction pending', color: 'Accent-Notice-Secondary' }
      case 'waiting':
        return { name: 'money', color: 'Label-Error-Secondary' }
      case 'paid':
        return { name: 'transaction paid', color: 'Label-Confirm' }
      case 'canceled':
        return { name: 'transaction canceled', color: 'Label-Error-Secondary' }
    }
  }, [status])

  return (
    <Container
      display={'flex'}
      className={clsx(styles['container'], {
        [styles['container_' + status]]: status,
        [styles['container_small']]: breakpoints.sm,
      })}
    >
      <Icon
        size={'as-is'}
        name={iconConf.name}
        className={clsx(styles['icon'], {
          [styles['icon_' + status]]: status,
        })}
      />
    </Container>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['new', 'pending', 'approved', 'declined']),
  breakpoints: PropTypes.object,
}

export default StatusIcon
